
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.125 0C.516 0 0 .516 0 1.125v15.75C0 17.484.516 18 1.125 18h15.75A1.14 1.14 0 0018 16.875V1.125A1.14 1.14 0 0016.875 0zm.952 2.077h13.846v13.846H2.077z"}})])
          )
        }
      }
    